import { createSelector } from '@reduxjs/toolkit';
import { employeesForStaffingCalendar } from './employees-for-staffing-calendar';
import type { EmployeeForStaffingCalendar } from './employee-for-staffing-calendar';
import { EmployeeViewModelStaffGroupEnum } from '@trinnvis/dabih-api-client';

export const employeeGroups = createSelector(employeesForStaffingCalendar, function (employees) {
  const employeeGroup1: EmployeeForStaffingCalendar[] = [];
  const employeeGroup2: EmployeeForStaffingCalendar[] = [];
  const employeeGroup3: EmployeeForStaffingCalendar[] = [];
  employees.forEach(function (employee) {
    if (employee.staffGroup) {
      if (employee.staffGroup === EmployeeViewModelStaffGroupEnum.G1) {
        employeeGroup1.push(employee);
      }
      if (employee.staffGroup === EmployeeViewModelStaffGroupEnum.G2) {
        employeeGroup2.push(employee);
      }
      if (employee.staffGroup === EmployeeViewModelStaffGroupEnum.G3) {
        employeeGroup3.push(employee);
      }
    } else {
      if (employee.treatmentProvider) {
        employeeGroup1.push(employee);
      } else if (employee.treatmentHelper) {
        employeeGroup2.push(employee);
      } else {
        employeeGroup3.push(employee);
      }
    }
  });
  return [employeeGroup1, employeeGroup2, employeeGroup3];
});
